import { SlTitledListComponent } from '@varo/graphql-schema-types';
import { amountStyles } from 'shared/components/vxl/TransactionListItem/TransactionListItem';

export const mapToTransactionSectionList = (section: SlTitledListComponent) => {
  return {
    title: section.title?.copy || '',
    transactions: section.children.map((transaction) => {
      return {
        titleText: transaction.primaryText?.copy || '',
        secondaryText: transaction.secondaryText?.copy || '',
        amountText: transaction.primaryDetail?.copy || '',
        balanceText: transaction.secondaryDetail?.copy || '',
        secondaryDetail: transaction.secondaryDetail?.copy || '',
        isPending: false,
        amountStyle: amountStyles.POSITIVE,
      };
    }),
  };
};
